module.exports = __webpack_public_path__ + "static/media/bg_lock.206fa92b.svg";